import { cn } from '@/lib/utils';

import { Themes } from '@/components/themeProviderUtils';

import { BadgeProps } from '@/decodo/components/atoms/badge';

export const MAX_TAG_AMOUNT_BEFORE_FOLD = 7;

export const mutualBadgeProps: BadgeProps = {
  size: 'l',
  classNames: {
    root: 'cursor-pointer',
  },
};
export const getSelectedTagProps = ({
  theme,
}: {
  theme?: Themes;
}): BadgeProps => ({
  ...mutualBadgeProps,
  colors: theme?.includes('light') ? 'brand-100' : 'brand-500',
  classNames: {
    root: cn('border', mutualBadgeProps.classNames?.root),
  },
  variant: 'filled',
});

export const unSelectedTagProps: BadgeProps = {
  ...mutualBadgeProps,
  colors: 'gray-300',
  variant: 'outlined',
  classNames: {
    root: cn(mutualBadgeProps.classNames?.root),
  },
};

export const SCRAPING_CARD_DATA_TRACKER_COMPONENT = 'scraping-template-card';

export const SCRAPING_TEMPLATE_LIBRARY_NUMBER_OF_ROWS = 3;
